module.exports = __webpack_public_path__ + "static/media/border.e59de9b2.png";